/**
 * Request utilities for service requests
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const getStoredToken = () => {
  return localStorage.getItem('auth_token');
};

export const getRequests = async (filters = {}) => {
  try {
    const token = getStoredToken();
    if (!token) {
      return { data: null, error: { message: 'Not authenticated' } };
    }

    const params = new URLSearchParams();
    if (filters.game) params.append('game', filters.game);
    if (filters.service_type) params.append('service_type', filters.service_type);
    if (filters.status) params.append('status', filters.status);

    const response = await fetch(`${API_BASE_URL}/requests?${params}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    const data = await response.json();

    if (!response.ok) {
      return { data: null, error: { message: data.error || 'Failed to fetch requests' } };
    }

    return { data: data.data || [], error: null };
  } catch (error) {
    return { data: null, error: { message: error.message || 'Network error' } };
  }
};

export const createRequest = async (requestData) => {
  try {
    const token = getStoredToken();
    if (!token) {
      return { data: null, error: { message: 'Not authenticated' } };
    }

    const response = await fetch(`${API_BASE_URL}/requests`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(requestData),
    });

    const data = await response.json();

    if (!response.ok) {
      return {
        data: null,
        error: {
          message: data.error || 'Failed to create request',
          ...(data.existing_request_id != null
            ? { existing_request_id: data.existing_request_id }
            : {}),
        },
      };
    }

    let row = data.data;
    // After POST, use boosting_requests UUID for navigation/cancel (same as GET /boosting/requests/active).
    if (row && row.boosting_request_id) {
      row = {
        ...row,
        service_request_id: row.id,
        id: row.boosting_request_id,
      };
    }

    return { data: row, error: null };
  } catch (error) {
    return { data: null, error: { message: error.message || 'Network error' } };
  }
};

export const getActiveBoostingRequest = async () => {
  try {
    const token = getStoredToken();
    if (!token) {
      return { data: null, error: null };
    }

    // Get user's active boosting requests (status: waiting)
    const response = await fetch(`${API_BASE_URL}/boosting/requests/active`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    if (response.ok) {
      const result = await response.json();
      if (result.data && result.data.length > 0) {
        return { data: result.data[0], error: null };
      }
    }

    return { data: null, error: null };
  } catch (error) {
    return { data: null, error: null };
  }
};

export const cancelBoostingRequest = async (requestId) => {
  try {
    const token = getStoredToken();
    if (!token) {
      return { data: null, error: { message: 'Not authenticated' } };
    }

    const response = await fetch(`${API_BASE_URL}/boosting/requests/${requestId}/cancel`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    const data = await response.json();

    if (!response.ok) {
      return { data: null, error: { message: data.error || 'Failed to cancel request' } };
    }

    return { data: data.data, error: null };
  } catch (error) {
    return { data: null, error: { message: error.message || 'Network error' } };
  }
};

